import { render } from "./GroupChatOptionsCard.vue?vue&type=template&id=57495e1e&scoped=true"
import script from "./GroupChatOptionsCard.vue?vue&type=script&lang=js"
export * from "./GroupChatOptionsCard.vue?vue&type=script&lang=js"

import "./GroupChatOptionsCard.vue?vue&type=style&index=0&id=57495e1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57495e1e"]])

export default __exports__